import { Grid, Typography, Box, useTheme } from '@mui/material';
import PlateIcons from '@shared/components/PlateIcons';
import PlateSeason from './PlateSeason';

import { getPlateAmount } from '@shared/helpers/getPlateAmount';
import PlateRibbon from './PlateRibbon';

const PlateContent = ({ data = {} }) => {
  const theme = useTheme();

  const {
    image_box,
    groups = {},
    ribbon_type = {},
    ribbon_text,
    season_type = {},
    season_text,
    title,
    //info,
    transfers = {},
    from,
  } = data;

  return (
    <Grid
      sx={{
        position: 'relative',
        width: 300,
        minHeight: 330,
        border: '1px solid rgba(34, 34, 34, 0.2)',
        borderRadius: 2,
        m: '15px auto',
        bgcolor: '#fff',
        overflow: 'hidden',
      }}
    >
      {/* Imagen */}
      <Grid sx={{ position: 'relative', width: '100%', height: 220 }}>
        <Box
          component="img"
          src={image_box}
          alt="imagen box"
          sx={{
            width: '100%',
            height: '220px',
            objectFit: 'cover',
            borderRadius: '6px 6px 0 0',
          }}
        />

        {transfers.name && (
          <Box
            id="plate-new-flag"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              bottom: 0,
              right: season_type && season_text ? 0 : 'auto',
              left: season_type && season_text ? 'auto' : 0,
              color: 'white',
              paddingLeft: '10px',
              paddingRight: '10px',
              height: 32,
              borderRadius: '6px 0px 6px 0px',
              backgroundColor: '#0000009c',
              fontFamily: 'Open Sans',
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {transfers.name}
          </Box>
        )}

        <Box
          id="plate-new-flag"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            color: theme.text1,
            paddingRight: '10px',
            height: 32,
            borderRadius: '6px 0 6px 0',
            backgroundColor: theme.primary,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {groups.icon && <PlateIcons icon={groups.icon} />}
          {groups.name?.toUpperCase()}
        </Box>

        {ribbon_type && <PlateRibbon ribbon={ribbon_type} text={ribbon_text} />}
        {!ribbon_type && season_type && (
          <Grid sx={{ position: 'absolute', top: 2, right: 2 }}>
            <PlateSeason season={season_type} text={season_text} />
          </Grid>
        )}
      </Grid>

      {/* Contenido de texto */}
      <Grid sx={{ p: '8px 16px', height: 46, overflowY: 'hidden' }}>
        {title && (
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 600,
              lineHeight: '33px',
              color: '#000',
            }}
          >
            {title}
          </Typography>
        )}

        {/* {info && (
          <Typography
            sx={{
              mt: 2.5,
              whiteSpace: 'pre-line',
              fontSize: 12,
              color: '#656565',
            }}
          >
            {info}
          </Typography>
        )} */}

        {/* {transfers.name && (
          <Typography sx={{ mt: 0, fontSize: 12, color: '#656565' }}>
            {transfers.name}
          </Typography>
        )} */}
      </Grid>

      {/* Footer con precio */}
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'absolute',
          bottom: 0,
          //borderTop: '1px solid rgba(34, 34, 34, 0.2)',
          width: '100%',
          height: 70,
          px: 3,
        }}
      >
        {from && (
          <Typography sx={{ color: '#6A6A6A', fontSize: 12 }}>
            A partir de
          </Typography>
        )}

        <Typography
          sx={{
            fontSize: 24,
            fontWeight: 'bold',
            color: '#000',
            position: 'relative',
            top: '-6px',
          }}
        >
          {getPlateAmount(data)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PlateContent;
